import type { IconSvgObject } from './types';

const DiagonalScrollPoint02Icon: IconSvgObject = [
  ["path", { d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 4.11735C10 4.11735 5.24049 3.69033 4.46539 4.46542C3.6903 5.2405 4.11739 10 4.11739 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 19.8826C14 19.8826 18.7595 20.3097 19.5346 19.5346C20.3097 18.7595 19.8826 14 19.8826 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DiagonalScrollPoint02Icon;
